// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck // TODO: fix type safety to delete this line
import { ArrowsLeftRight, Square, TreeStructure } from '@phosphor-icons/react';
import AndroidLogo from '@whistler-ui/k2/components/CustomIcons/AndroidLogo';
import {
  AppleLockLogo,
  AppleLogo,
} from '@whistler-ui/k2/components/CustomIcons/AppleLogo';
import { Tooltip } from '@whistler-ui/k2/components/Tooltip';
import { CustomIconsType } from '@whistler-ui/k2/types';
import React from 'react';

import {
  FiveG,
  IPad,
  MSO,
  PhoneVerification,
  RCS,
  Satmode,
  Transfer,
  VoLTE,
  VoWifi,
  Watch,
} from '../components/Icons';

export const AppleIcon = ({
  size = 20,
  fill = '#5e656c',
}: Partial<CustomIconsType>) => {
  return <AppleLogo size={size} fill={fill} />;
};

export const AppleLockIcon = ({
  size = 28,
  fill = '#5e656c',
}: Partial<CustomIconsType>) => {
  return <AppleLockLogo size={size} fill={fill} />;
};

export const AndroidIcon = ({
  size = 20,
  fill = '#5e656c',
}: Partial<CustomIconsType>) => {
  return <AndroidLogo size={size} fill={fill} />;
};

export const BlankIcon = ({
  size = 20,
  fill = '#ffffff',
}: Partial<CustomIconsType>) => {
  return <AndroidLogo size={size} fill={fill} />;
};

export const USE_CASE_EMPTY = {
  EMPTY: '',
} as const;

export const USE_CASE_API_TAGS = {
  EAP_AKA_AUTH: 'EAP_AKA_AUTH',
  EAP_AKA_VALIDATION: 'EAP_AKA_VALIDATION',
  HEALTH_CHECK: 'HEALTH_CHECK',
  ENTITLEMENT_INFO: 'ENTITLEMENT_INFO',
  PHONE_NUM_INFO: 'PHONE_NUM_INFO',
  PROVISION_VOLTE: 'PROVISION_VOLTE',
  DEPROVISION_VOLTE: 'DEPROVISION_VOLTE',
  PROVISION_VOWIFI: 'PROVISION_VOWIFI',
  DEPROVISION_VOWIFI: 'DEPROVISION_VOWIFI',
  WIFI_STATUS_INFO: 'WIFI_STATUS_INFO',
  FIVE_G_PLAN_INFO: 'FIVE_G_PLAN_INFO',
  ESIM_TRANSFER_TYPE: 'ESIM_TRANSFER_TYPE',
  ESIM_VALIDATE: 'ESIM_VALIDATE',
  ESIM_ORDER: 'ESIM_ORDER',
  TRANSFER: 'TRANSFER',
  CONFIRM_TRANSFER: 'CONFIRM_TRANSFER',
  ESIM_CANCEL: 'ESIM_CANCEL',
  SIM_SWAP: 'SIM_SWAP',
  ESIM_RELEASE: 'ESIM_RELEASE',
  ROAMING_INFO: 'ROAMING_INFO',
  SIM_STATUS: 'SIM_STATUS',
  PLAN_OFFERS: 'PLAN_OFFERS',
  PROVISION_SUBSCRIPTION: 'PROVISION_SUBSCRIPTION',
  DEPROVISION_SUBSCRIPTION: 'DEPROVISION_SUBSCRIPTION',
  CARRIER_AUTHENTICATION: 'CARRIER_AUTHENTICATION',
  CHANGE_SUBSCRIPTION: 'CHANGE_SUBSCRIPTION',
  NOT_IMPLEMENTED_API_WEBSHEET: 'NOT_IMPLEMENTED_API_WEBSHEET',
  WEBSHEET_ESIM_TRANSFER: 'WEBSHEET_ESIM_TRANSFER',
  WEBSHEET_ESIM_TRANSFER_DIRECT: 'WEBSHEET_ESIM_TRANSFER_DIRECT',
  WS_ESIM_QUICK_TRANSFER: 'WS_ESIM_QUICK_TRANSFER',
  WS_WATCH_ACTIVATE: 'WS_WATCH_ACTIVATE',
  WS_VOWIFI_ACTIVATE: 'WS_VOWIFI_ACTIVATE',
  ...USE_CASE_EMPTY,
} as const;

// USE CASE BASE TAGS
export const USE_CASE_TAGS = {
  Baseline: 'Baseline',
  VoLTE_Default_On: 'VoLTE_Default_On',
  VoLTE: 'VoLTE',
  VoWiFi: 'VoWiFi',
  '5G': '5G',
  Device_Transfer: 'Device_Transfer',
  Atomic_Device_Transfer: 'Atomic_Device_Transfer',
  Watch_Activation: 'Watch_Activation',
  iPhone_Handoff: 'iPhone_Handoff',
  iPad_Activation: 'iPad_Activation',
  RCS_Activation: 'RCS_Activation',
  RCS_Activation_Carrier_Provided_Token:
    'RCS_Activation_Carrier_Provided_Token',
  Phone_Number_Verification: 'Phone_Number_Verification',
  MSO_Subscription_Management: 'MSO_Subscription_Management',
  Cross_Platform_Transfer: 'Cross_Platform_Transfer',
  Satmode: 'Satmode',
  ...USE_CASE_EMPTY,
} as const;

export const USE_CASE_TEST_CASE_TAGS = {
  DT_FULL_PSIM_TO_ESIM_ANDROID: 'DT_FULL_PSIM_TO_ESIM_ANDROID',
  DT_FULL_ESIM_TO_ESIM_ANDROID: 'DT_FULL_ESIM_TO_ESIM_ANDROID',
  DT_FULL_CONVERSION_ANDROID: 'DT_FULL_CONVERSION_ANDROID',
  DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID:
    'DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID',
  DT_FULL_WEB_SHEET_ESIM_TO_ESIM_ANDROID:
    'DT_FULL_WEB_SHEET_ESIM_TO_ESIM_ANDROID',
  DT_FULL_WEB_SHEET_CONVERSION_ANDROID: 'DT_FULL_WEB_SHEET_CONVERSION_ANDROID',
  DT_FULL_PSIM_TO_ESIM: 'DT_FULL_PSIM_TO_ESIM',
  DT_FULL_ESIM_TO_ESIM: 'DT_FULL_ESIM_TO_ESIM',
  DT_FULL_CONVERSION: 'DT_FULL_CONVERSION',
  DT_FULL_WEB_SHEET_PSIM_TO_ESIM: 'DT_FULL_WEB_SHEET_PSIM_TO_ESIM',
  DT_FULL_WEB_SHEET_ESIM_TO_ESIM: 'DT_FULL_WEB_SHEET_ESIM_TO_ESIM',
  DT_FULL_WEB_SHEET_CONVERSION: 'DT_FULL_WEB_SHEET_CONVERSION',
  ATOMIC_DT_FULL_PSIM_TO_ESIM: 'ATOMIC_DT_FULL_PSIM_TO_ESIM',
  ATOMIC_DT_FULL_ESIM_TO_ESIM: 'ATOMIC_DT_FULL_ESIM_TO_ESIM',
  ATOMIC_DT_FULL_CONVERSION: 'ATOMIC_DT_FULL_CONVERSION',
  ATOMIC_DT_FULL_PSIM_TO_ESIM_ANDROID: 'ATOMIC_DT_FULL_PSIM_TO_ESIM_ANDROID',
  ATOMIC_DT_FULL_ESIM_TO_ESIM_ANDROID: 'ATOMIC_DT_FULL_ESIM_TO_ESIM_ANDROID',
  ATOMIC_DT_FULL_CONVERSION_ANDROID: 'ATOMIC_DT_FULL_CONVERSION_ANDROID',
  WATCH_ACTIVATION_SUCCESS_ANDROID: 'WATCH_ACTIVATION_SUCCESS_ANDROID',
} as const;

const defaultIcons = { ios: AppleIcon, android: AndroidIcon };

export const USE_CASE_ICONS = {
  [USE_CASE_TAGS['Device_Transfer']]: defaultIcons,
  [USE_CASE_TAGS['Watch_Activation']]: defaultIcons,
  [USE_CASE_TAGS['iPad_Activation']]: { ios: AppleIcon },
  [USE_CASE_TAGS['RCS_Activation']]: defaultIcons,
  [USE_CASE_TAGS['RCS_Activation_Carrier_Provided_Token']]: defaultIcons,
  [USE_CASE_TAGS['Phone_Number_Verification']]: { android: AndroidIcon },
  [USE_CASE_TAGS['Atomic_Device_Transfer']]: defaultIcons,
  [USE_CASE_TAGS['5G']]: defaultIcons,
  [USE_CASE_TAGS['VoWiFi']]: defaultIcons,
  [USE_CASE_TAGS['VoLTE']]: defaultIcons,
  [USE_CASE_TAGS['Baseline']]: defaultIcons,
  [USE_CASE_TAGS['New_Device_Transfer']]: defaultIcons,
  [USE_CASE_TAGS['VoLTE_Default_On']]: { ios: AppleIcon },
  [USE_CASE_TAGS['MSO_Subscription_Management']]: { android: AndroidIcon },
  [USE_CASE_TAGS['Satmode']]: { android: AndroidIcon },
  [USE_CASE_TAGS['Cross_Platform_Transfer']]: defaultIcons,
} as const;

// This is hardcoded logic that should live in the backend  (UES-6548 & UES-6504)
export const UNAVAILABLE_IOS_USE_CASE = {
  iPad_Activation: AppleIcon,
  Watch_Activation: ({ t }) =>
    (
      <Tooltip
        align="right"
        trigger={
          <div>
            <AppleLockIcon />
          </div>
        }
        contentClassName="max-w-[300px]"
        content={t('componentUseCaseCheckbox_locked_ios')}
      />
    ) as React.FC<{ t: (txt: string) => string }>,
  '5G': ({ t }) =>
    (
      <Tooltip
        align="right"
        trigger={
          <div>
            <AppleLockIcon />
          </div>
        }
        contentClassName="max-w-[300px]"
        content={t('componentUseCaseCheckbox_locked_ios')}
      />
    ) as React.FC<{ t: (txt: string) => string }>,
};

// This is hardcoded logic that should live in the backend (https://netlync.atlassian.net/browse/UES-9701)
export const UNAVAILABLE_USE_CASE = {
  Cross_Platform_Transfer: {
    ios: AppleIcon,
    android: AndroidIcon,
  },
};

export const useCasesIconsMap = ({ size = 32, color = undefined }) => {
  const map = new Map([
    ['Baseline', <TreeStructure size={size} color={color} />],
    ['VoLTE', <VoLTE size={size} color={color} />],
    ['VoLTE_Default_On', <VoLTE size={size} color={color} />],
    ['VoWiFi', <VoWifi size={size} color={color} />],
    ['5G', <FiveG size={size} color={color} />],
    ['Device_Transfer', <Transfer size={size} color={color} />],
    ['Watch_Activation', <Watch size={size} color={color} />],
    ['iPad_Activation', <IPad size={size} color={color} />],
    ['RCS_Activation', <RCS size={size} color={color} />],
    [
      'RCS_Activation_Carrier_Provided_Token',
      <RCS size={size} color={color} />,
    ],
    [
      'Phone_Number_Verification',
      <PhoneVerification size={size} color={color} />,
    ],
    ['Atomic_Device_Transfer', <Transfer size={size} color={color} />],
    ['New_Device_Transfer', <ArrowsLeftRight size={size} color={color} />],
    ['MSO_Subscription_Management', <MSO size={size} color={color} />],
    ['Satmode', <Satmode size={size} color={color} />],
    ['Cross_Platform_Transfer', <Transfer size={size} color={color} />],
  ]);

  const getWithDefault = (key: string) => {
    return map.get(key) || <Square size={size} color={color} />;
  };

  return { map, getWithDefault };
};

export const useCaseStatuses = (tag: string) => {
  const statusMap = {
    live: 'Live',
    'in-review': 'In Review',
    test: 'Test',
  };

  return statusMap[tag] || 'Test';
};

export const ENTITLEMENTS_IMPLEMENT_TABS = [];
export const CARRIER_API = 'CarrierAPI';

// Add/Remove useCase tags that will display the "New!" banner
export const NEW_USE_CASES = {
  iPhone_Handoff: true,
  RCS_Activation: true,
  RCS_Activation_Carrier_Provided_Token: true,
  Phone_Number_Verification: true,
  Atomic_Device_Transfer: true,
  VoLTE_Default_On: true,
  New_Device_Transfer: true,
  MSO_Subscription_Management: true,
  Cross_Platform_Transfer: true,
  Satmode: true,
};

// Add/Remove useCase tags that will not show Use Case Tests
export const HIDE_USE_CASE_TESTS = {
  VoWiFi: true,
} as const;

export const ENTITLEMENTS_ROUTES = {
  SETUP_ENVIRONMENT: {
    name: 'SETUP_ENVIRONMENT',
    slug: 'setup-environment',
  },
  WEBSHEET_BRANDING: {
    name: 'WEBSHEET_BRANDING',
    slug: 'websheet-branding',
  },
  ESIM_QUICK_TRANSFER: {
    name: 'ESIM_QUICK_TRANSFER',
    slug: 'esim-transfer',
  },
  WATCH: {
    name: 'WATCH',
    slug: 'watch',
  },
  RCS: {
    name: 'RCS',
    slug: 'rcs',
  },
  CARRIER_AUTHENTICATION: {
    name: 'CARRIER_AUTHENTICATION',
    slug: 'carrier-authentication',
  },
  NETWORK_DETAILS: {
    name: 'NETWORK_DETAILS',
    slug: 'network_details',
  },
  VO_WIFI: {
    name: 'VO_WIFI',
    slug: 'vo_wifi',
  },
  GSMA_NSX_SETTINGS: {
    name: 'GSMA_NSX_SETTINGS',
    slug: 'gsma-nsx-settings',
  },
} as const;

export const SETUP_ENVIRONMENT_SECTION_PARAM = 'section';

export const SETUP_ENVIRONMENT_SECTIONS = {
  SIM_AUTH_PROTECTION: 'sim-auth-protection',
} as const;
